export const manifest = {
  screens: {
    scr_14vpg2: { name: "Landing", route: "/", position: {"x":160,"y":220} },
    scr_9nhogx: { name: "Villa Details", route: "/villa/v1", position: {"x":1560,"y":220} },
    scr_8m90yg: { name: "Agent Login", route: "/agent/login", position: {"x":160,"y":2200} },
    scr_72cvv0: { name: "Agent Dashboard", route: "/agent", position: {"x":1560,"y":2200} },
    scr_s6e6y0: { name: "New Booking", route: "/agent/new-booking", position: {"x":2960,"y":2200} },
    scr_555r3l: { name: "Admin Dashboard", route: "/admin", position: {"x":160,"y":4180} },
  },
  sections: {
    sec_vbk9q6: { name: "Customer Browsing", x: 0, y: 0, width: 2920, height: 1180 },
    sec_vhmq3n: { name: "Agent Workflow", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_a46z2e: { name: "Admin Panel", x: 0, y: 3960, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_vbk9q6", children: [
      { kind: "screen", id: "scr_14vpg2" },
      { kind: "screen", id: "scr_9nhogx" },
    ] },
    { kind: "section", id: "sec_vhmq3n", children: [
      { kind: "screen", id: "scr_8m90yg" },
      { kind: "screen", id: "scr_72cvv0" },
      { kind: "screen", id: "scr_s6e6y0" },
    ] },
    { kind: "section", id: "sec_a46z2e", children: [
      { kind: "screen", id: "scr_555r3l" },
    ] },
  ],
}
